<template>
  <v-container fluid class="country-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-country`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-image-filter-hdr</v-icon>
            Country
          </v-tab>
          <v-tab-item
            :value="'tab-country'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <v-form>
                      <p class="text-h5">Edit Country</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'countrycode')"
                        v-bind:value="initvalue.countrycode"
                        placeholder="Country Code"
                        persistent-hint
                        single-line hint="Enter the country code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'countryname')"
                        v-bind:value="initvalue.countryname"
                        placeholder="Country Name"
                        persistent-hint
                        single-line hint="Enter the country name">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'countryinfo')"
                        v-bind:value="initvalue.countryinfo"
                        placeholder="Country Info"
                        persistent-hint
                        single-line hint="Enter the country info">
                      </v-text-field>
                      <v-select
                        class="mb-4"
                        :items=items
                        :value="initvalue.countrytype"
                        outlined
                        dense
                        v-on:change="updateChangedValue($event, 'countrytype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the country type">
                      </v-select>
                      <v-switch
                          color="primary"
                          v-on:change="updateChangedValue($event, 'countrystatus')"
                          v-bind:label="initvalue.countrystatus"
                          v-model="initvalue.countrystatus"
                          value="Active"
                      ></v-switch>
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/country/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editCountry()">
                            Save
                          </v-btn>
                      </div>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      country: {},
      detail: {},
      photo: {},
      pin: {
        error: false,
        error2: false
      },
      initvalue: {},
      items: ['Country', 'Other Country'],
      switch1: false,
      switch2: false,
    }
  },
  methods: {
    ...mapActions('Country', ['updateCountryRequest','getCountriesRequest']),
    editCountry() {
      this.country._id = this.initvalue._id;
      this.updateCountryRequest(this.country);
      this.getCountriesRequest();
      router.push('/country/list');
    },
    updateChangedValue(value, field){
      this.country[field] = value;
    },
  },
  computed: {
    ...mapState('Country', ['isReceiving'])
  },
  created () {
    this.initvalue = this.$route.params;
    if(!this.initvalue._id) this.$router.push({ name: 'CountryList' });
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
